module.exports = __webpack_public_path__ + "img/iq.980cc04.svg";